export const BPOINT_1439_BANDS = [
  { id: "NESSUNA", name: "Nessuna richiesta" },
  { id: "FINO_5000", name: "Fino a 5.000 €" },
  { id: "DA_5001_10000", name: "Da 5.001 a 10.000 €" },
  { id: "DA_10001_50000", name: "Da 10.001 a 50.000 €" },
  { id: "OLTRE_50000", name: "Oltre 50.000 €" },
];

export const isBpoint1439 = (prestazione) =>
  String(prestazione?.tipologia_fatturazione || "").toUpperCase() === "B" &&
  Number(String(prestazione?.nuovo_codice_ago || prestazione?.codice || "").replace(/^0+/, "")) === 1439;

export const calculateBpoint1439 = ({ subordinati, gestioneSeparata, altraGestione, domandeRespinte, parametri }) => {
  const fasce = [subordinati, gestioneSeparata, altraGestione].map((fascia) => fascia || "NESSUNA");
  if (fasce.some((fascia) => !BPOINT_1439_BANDS.some((item) => item.id === fascia))) return null;
  const respinte = Number(domandeRespinte);
  if (!Number.isInteger(respinte) || respinte < 0) return null;
  const importi = {
    NESSUNA: 0,
    FINO_5000: Number(parametri?.quota_fino_5000),
    DA_5001_10000: Number(parametri?.quota_5001_10000),
    DA_10001_50000: Number(parametri?.quota_10001_50000),
    OLTRE_50000: Number(parametri?.quota_oltre_50000),
  };
  const valori = [...Object.values(importi), Number(parametri?.quota_domanda_aggiuntiva), Number(parametri?.importo_minimo)];
  if (valori.some((value) => !Number.isFinite(value) || value < 0)) return null;
  const totale = fasce.reduce((sum, fascia) => sum + importi[fascia], 0) + respinte * Number(parametri.quota_domanda_aggiuntiva);
  return Math.round(Math.max(Number(parametri.importo_minimo), totale) * 100) / 100;
};
